/* "We have rebuilt this site" notice, with the launch-pricing reminder.

   TRIGGER: 10 seconds of dwell, or exit intent if that comes sooner. Once per visitor.

   TWO POPUPS, SEQUENCED. The email-capture popup (luma-popup.js) also runs on this site.
   They are split by MOMENT so they never stack — two popups in one session is a bounce:
       this one → arrival    (10s dwell, or exit intent)
       email    → departure  (exit intent, or 55% scroll)
   luma-popup.js stands down while #lrel is on screen. Do not give this file a later dwell
   than the email popup or the sequence inverts and this notice is never seen — which is
   exactly what happened when this ran at 30s.

   WHY IT IS NOT ON THE NAV LINKS: the original version appeared when you clicked
   Shop / Discover / About, but only because those links were BROKEN (they pointed at
   anchors that did not exist on the homepage, so every click fell through to the overlay).
   Those links now work. Re-attaching this to them would break navigation again.

   THE 25% CLAIM IS CONDITIONAL, AND THAT IS DELIBERATE.
   Under the EU Omnibus / Price Indication Directive a "was" price must be the lowest price
   actually charged in that market in the previous 30 days. The launch reference price was
   never charged in the EEA, which is why Shopify is set to hide compare-at prices for EEA
   customers on this store. So we only state a percentage where a compare-at price is
   genuinely displayed; everywhere else the copy drops the number. Do not merge the two
   body strings. */
(function(){
  var T = window.LUMA_RELAUNCH || {};
  var DWELL_MS = 10000;

  function blocked(){
    if (window.Shopify && window.Shopify.designMode) return true;
    if (/[?&]nopop=1/.test(location.search)) return true;
    if (/^\/(cart|checkout|account|challenge)/.test(location.pathname)) return true;
    try {
      if (sessionStorage.getItem('luma_relaunch_seen') === '1') return true;
      if (localStorage.getItem('luma_relaunch_x') === '1') return true;
    } catch(e){}
    if (document.getElementById('lpop')) return true;   /* email popup on screen right now */
    return false;
  }

  /* Only claim a percentage where a compare-at price is actually rendered. */
  function discountLine(){
    var el = document.querySelector('.lp .lwas, .lp s, .lp del, .bbadge');
    var shown = !!(el && (el.textContent || '').trim());
    return shown ? (T.bodyOffer || '') : (T.bodyPlain || '');
  }

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  var wrap, shown = false;

  function build(){
    var st = document.createElement('style');
    st.textContent = ''
    + '#lrel{position:fixed;inset:0;z-index:2147483100;display:flex;align-items:center;'
    +   'justify-content:center;padding:20px;opacity:0;pointer-events:none;transition:opacity .38s ease}'
    + '#lrel.on{opacity:1;pointer-events:auto}'
    + '#lrel .lrbg{position:absolute;inset:0;background:rgba(16,16,16,.55)}'
    + '#lrel .lrbox{position:relative;background:#f7f4ef;color:#101010;width:100%;max-width:430px;'
    +   'padding:44px 38px 34px;text-align:center;box-shadow:0 24px 70px rgba(0,0,0,.3);'
    +   'transform:translateY(14px);transition:transform .38s cubic-bezier(.2,.7,.3,1);'
    +   'font-family:Inter,-apple-system,"Segoe UI",Arial,sans-serif}'
    + '#lrel.on .lrbox{transform:translateY(0)}'
    + '#lrel .lrx{position:absolute;top:10px;right:10px;width:36px;height:36px;border:0;background:none;'
    +   'cursor:pointer;font-size:20px;color:#8b857d;padding:0}'
    + '#lrel .lre{font-size:10.5px;letter-spacing:.24em;text-transform:uppercase;color:#8b857d;margin:0 0 16px}'
    + '#lrel h2{font-size:24px;line-height:1.24;font-weight:600;letter-spacing:-.01em;margin:0 0 14px}'
    + '#lrel p.lrb{font-size:14px;line-height:1.62;color:#4a453f;margin:0 auto 24px;max-width:330px}'
    + '#lrel a.lrgo{display:block;max-width:330px;margin:0 auto;background:#101010;color:#fff;'
    +   'text-decoration:none;padding:15px;font-size:11px;font-weight:700;letter-spacing:.15em;'
    +   'text-transform:uppercase}'
    + '#lrel a.lrgo:hover{background:#2c2c2c}'
    + '@media(max-width:640px){#lrel{align-items:flex-end;padding:0}'
    +   '#lrel .lrbox{max-width:none;padding:34px 22px 26px}#lrel h2{font-size:21px}}'
    + '@media(prefers-reduced-motion:reduce){#lrel,#lrel .lrbox{transition:none}}';
    document.head.appendChild(st);

    wrap = document.createElement('div');
    wrap.id = 'lrel';
    wrap.setAttribute('role','dialog');
    wrap.setAttribute('aria-modal','true');
    wrap.innerHTML =
        '<div class="lrbg"></div>'
      + '<div class="lrbox">'
      +   '<button class="lrx" type="button" aria-label="' + esc(T.close || 'Close') + '">&#215;</button>'
      +   '<p class="lre">' + esc(T.eyebrow || '') + '</p>'
      +   '<h2>' + esc(T.heading || '') + '</h2>'
      +   '<p class="lrb">' + esc(discountLine()) + '</p>'
      +   '<a class="lrgo" href="' + esc(T.url || '/') + '">' + esc(T.cta || '') + '</a>'
      + '</div>';
    document.body.appendChild(wrap);
  }

  function close(){
    if (!wrap) return;
    wrap.classList.remove('on');
    try { localStorage.setItem('luma_relaunch_x','1'); } catch(e){}
    setTimeout(function(){ if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 400);
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e){ if (e.key === 'Escape') close(); }

  function open(){
    if (shown || blocked()) return;
    shown = true;
    try { sessionStorage.setItem('luma_relaunch_seen','1'); } catch(e){}
    build();
    requestAnimationFrame(function(){ wrap.classList.add('on'); });
    document.addEventListener('keydown', onKey);
    wrap.addEventListener('click', function(e){
      if (e.target.classList.contains('lrbg') || e.target.classList.contains('lrx')) close();
    });
  }

  setTimeout(open, DWELL_MS);
  document.addEventListener('mouseout', function(e){
    if (!e.relatedTarget && e.clientY <= 4) open();
  });
})();